import {Pipe, PipeTransform} from '@angular/core';
              
@Pipe({
    name: 'PipeTruncate',
    pure: true
})
export class PipeTruncatePipe implements PipeTransform {
    transform(value: string, args: string[]): string {
        // if (Array.isArray(value))
        //     value = value.pop();
        if (typeof value === 'undefined' || value === null || value === '') return '...';
        const limit = args.length > 0 ? parseInt(args[0], 10) : 20;
        const trail = args.length > 1 ? args[1] : '...';
        return value.length > limit ? value.substring(0, limit) + trail : value;
    }
}
